import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import BulletinEditView from "~bulletins/components/bulletin-edit-view-new"
import BulletinListView from "~bulletins/components/user-bulletins-list-view"
import {Typography} from '@mui/material'

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class BulletinList extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state

    var view 
    if (status === "loading") {
      view = <LoadingView />
    } else {
      view = <BulletinListView></BulletinListView> 
    }

    return (
      <AppView>
        <Require classes={{}} requireOneOfFeatures={["bulletin_admin"]}>
            <Typography id="bulletinAdminTitle" variant="h5" className={classes.heading}>
               User Bulletins
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(BulletinList)
